import { cn } from '@dialogueconsulting/sked-ui/lib/utils'
import type { CSSProperties, PropsWithChildren } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from 'ui/avatar'

export interface AvatarComponentProps extends React.HTMLAttributes<HTMLSpanElement> {
  src: string
  alt: string
  avatarColor?: string
}

function AvatarComponent({
  src,
  alt,
  avatarColor,
  className,
  style,
  ...props
}: PropsWithChildren<AvatarComponentProps>) {
  const initial = alt.substring(0, 2).toUpperCase() // first two letters

  return (
    <Avatar
      className={cn(
        'grid size-auto place-content-center rounded-none bg-white',
        className
      )}
      style={{ '--avatar-color': avatarColor, ...style } as CSSProperties}
      {...props}
    >
      <AvatarImage src={src} alt={alt} />
      <AvatarFallback className="bg-[var(--avatar-color)]">
        {initial}
      </AvatarFallback>
    </Avatar>
  )
}

export default AvatarComponent
